import { Link } from "react-router";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import type { SiteControllerSettingBeds24FormModel } from "@/components/features/settings/site-controller/model/beds24/type";
import type { SiteControllerSettingBeds24FormModelMethodsType } from "@/components/features/settings/site-controller/model/beds24/use-case/use-create-model/methods";

import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";
import OpenInNew from "@/components/ui/icon/open-in-new";

type Props = {
	beds24AuthenticationApiKey: SiteControllerSettingBeds24FormModel["ViewModel"]["beds24AuthenticationApiKey"]; //
	onSetBeds24AuthenticationApiKey: SiteControllerSettingBeds24FormModelMethodsType["siteControllerSettingBeds24FormModelMethods"]["onSetBeds24AuthenticationApiKey"];

	beds24AuthenticationPropKey: SiteControllerSettingBeds24FormModel["ViewModel"]["beds24AuthenticationPropKey"]; //
	onSetBeds24AuthenticationPropKey: SiteControllerSettingBeds24FormModelMethodsType["siteControllerSettingBeds24FormModelMethods"]["onSetBeds24AuthenticationPropKey"];
};

export const SettingsSiteControllerBeds24PropAndApiKey = ({
	beds24AuthenticationApiKey,
	onSetBeds24AuthenticationApiKey,
	beds24AuthenticationPropKey,
	onSetBeds24AuthenticationPropKey,
}: Props) => {
	return (
		<QuestionForMain
			required={true}
			title={"Beds24管理画面で設定したキーの登録"}
			inputChildren={
				<div className="space-y-8">
					<div className="space-y-4">
						<div className="flex gap-x-2">
							※
							<Link
								to={"https://beds24.com/control3.php?pagetype=accountpassword"}
								target="_blank"
								className="flex items-center gap-x-1 text-link-400 underline-offset-4 hover:underline"
								viewTransition
							>
								Beds24管理画面（APIキー）
								<OpenInNew className="w-5" />
							</Link>
							で設定した APIキー を入力してださい
						</div>
						<InputTextField
							type="text"
							label="APIキー"
							className="w-full xl:w-1/2"
							value={beds24AuthenticationApiKey?.value}
							errorMessage={beds24AuthenticationApiKey?.error}
							handleChange={onSetBeds24AuthenticationApiKey}
						/>
					</div>
					<div className="space-y-4">
						<div className="flex gap-x-2">
							※
							<Link
								to={"https://beds24.com/control3.php?pagetype=propertyassociation"}
								target="_blank"
								className="flex items-center gap-x-1 text-link-400 underline-offset-4 hover:underline"
								viewTransition
							>
								Beds24管理画面（APIアクセス → propキー）
								<OpenInNew className="w-5" />
							</Link>
							で設定した propキー を入力してださい
						</div>
						<InputTextField
							type="text"
							label="propキー"
							className="w-full xl:w-1/2"
							value={beds24AuthenticationPropKey?.value}
							errorMessage={beds24AuthenticationPropKey?.error}
							handleChange={onSetBeds24AuthenticationPropKey}
						/>
					</div>
				</div>
			}
		/>
	);
};

SettingsSiteControllerBeds24PropAndApiKey.displayName = "SettingsSiteControllerBeds24PropAndApiKey";
